export const baseUrl = 'forms-digital/v1';
export const baseUrlV2 = 'forms-digital/v2';
